<template>
    <div id="loan-supplier-selector">
        <div class="vx-row">
            <div class="vx-col w-full">
                <vx-card class="mb-4">
                    <h3 class="bold big-title mb-2">Asignar <span>proveedor</span>.</h3>
                    <p>
                        Asigna un proveedor a la solicitud de crédito seleccionada, toma en cuenta su ubicación y la tecnología solicitada.
                    </p>
                </vx-card>
            </div>
            <!-- INFORMACIÓN DEL PROVEEDOR -->
            <div class="vx-col sm:w-full">
                <vx-card>
                    <div class="flex justify-between">
                        <h5 class="mb-2 bold">Proveedores</h5>
                        <vs-button 
                            size="small"
                            @click.stop="requestAssignment" 
                            :disabled="supplierSelected == null">Confirmar asignación</vs-button>
                    </div>
                    <div class="w-full mb-base">
                        <label class="bold mt-3">Selecciona un proveedor</label>
                        <v-select
                            label="text"
                            class="w-full"
                            v-model.lazy="supplierSelected"
                            name="eventSelected"
                            :searchable="true"
                            :options="suppliersList"
                            :reduce="text => text.value"
                            placeholder="Seleccione una opción">
                            <div slot="no-options">No hay coincidencias</div> 
                        </v-select>
                    </div>
                    <div v-if="supplier != null" class="w-full">
                        <vs-divider></vs-divider>    
                        <h5 class="mb-base bold">Detalle del proveedor</h5>
                        <div class="vx-row">
                            <!-- detalle del proveedor -->
                            <div class="vx-col w-1/2 centered">
                                <div class="con-example-images">
                                    <img v-if="logo_url !== null" :src="logo_url" alt="Logo">
                                    <img v-else :src="photoURL" alt="Logo">
                                </div>
                                <h4>{{ supplier.tradename }}</h4>
                                <h6>{{ supplier.email }}</h6>
                                <h6>SID: <strong>{{ supplierSelected }}</strong> | UID: <strong>{{ supplier.user_id }}</strong></h6>
                                <h6 class="bold">{{ supplier.type == 'PM' ? 'Persona Moral' : 'Persona Física' }}</h6>
                                <h6>CLABE STP: <strong>{{ stpData != null ? stpData.stp_clabe : 'No generada' }}</strong></h6>
                                <h6>Última actualización: <br><strong>{{ supplier.update_profile_info.last_verified_date_log !== null ?
                                    logDateFormat(supplier.update_profile_info.last_verified_date_log.date) : '--' }}</strong></h6>
                            </div>
                            <div class="vx-col w-1/2">
                                <!-- ESTADO DEL PERFIL -->
                                <div class="vx-col sm:w-full border-rg">
                                    <div class="mb-4">
                                        <h6 class="bold"> 
                                            <span>
                                            <vs-icon icon="done"></vs-icon>
                                            </span>
                                            Estatus del proveedor
                                        </h6>
                                        <vs-chip v-if="supplier.verifiedDate == null && supplier.verificationRequestDate == null" transparent color="primary">
                                            <span class="bold text-xs">Nuevo solicitante</span>
                                        </vs-chip>
                                        <vs-chip v-if="supplier.verifiedDate == null && supplier.verificationRequestDate != null" transparent color="warning">
                                            <span class="bold text-xs">En verificación</span>
                                        </vs-chip>
                                        <vs-chip v-if="supplier.verifiedDate != null" transparent color="success">
                                            <span class="bold text-xs">Verificado</span>
                                        </vs-chip>
                                        <br>
                                    </div>
                                    <div class="mb-4">
                                        <h6 class="bold">
                                            <span>
                                            <vs-icon icon="perm_identity"></vs-icon>
                                            </span>
                                            Verificación de identidad
                                        </h6>
                                        <user-identity-verification :user-id="supplier.user_id" />
                                    </div>
                                    <div class="mb-base">
                                        <h6 class="bold">
                                            <span>
                                            <vs-icon icon="gavel"></vs-icon>
                                            </span>
                                            Perfil Legal
                                        </h6>
                                        <h6>Estado: <br><strong>{{ getLegalProfileStatus(supplier.legalProfile) }}</strong></h6>
                                        <h6>Última Actualización: <br><strong>{{ supplier.legalProfile != null ? logDateFormat(supplier.legalProfile.updated_at) : "No se ha verificado el perfil legal" }}</strong></h6>
                                    </div>
                                </div>
                            </div>
                            <!-- cartera vencida -->
                            <vs-divider></vs-divider>
                            <div class="vx-col w-full">
                                <due-portfolio-supplier-stats
                                    v-if="supplierSelected != null" 
                                    :realTime="true"
                                    :supplierId="supplierSelected"/>
                            </div>
                        </div>
                    </div>

                </vx-card>
            </div>
        </div>
    </div>
</template>

<script>
import formatHelper from '@mixins/formatHelper';
import dateHelper from '@mixins/dateHelper';
import SupplierDetails from "@views/admin/projects/process-flow/SupplierDetails.vue";
import UserIdentityVerification from '@components/profile_shared/UserIdentityVerification';
import DuePortfolioSupplierStats from "@components/supplier/DuePortfolioSupplierStats";
export default {
    name: "LoanSupplierSelector",
    mixins: [formatHelper, dateHelper],
    props: ["loan"],
    data: () => ({
        currentSupplierID: null
        , showFormPromptSupplierInfo: false
        , showFormPromptSupplierAssignment: false
        , suppliersList: []
        , supplierSelected: null
        , loanIdSelected: null
        , supplier: null
        , stpData: null
        , logo_doc_file_url: ''
        , avatar: require('@assets/images/supplier_avatar.png')
        , familyGroupId: 1
    }),
    components: {
        SupplierDetails,
        UserIdentityVerification,
        DuePortfolioSupplierStats
    },
    computed: {
        photoURL() {
            return this.avatar;
        },
        logo_url() {
            if (this.logo_doc_file_url !== null && this.logo_doc_file_url !== '') {
                return this.ApiDomain + this.logo_doc_file_url;
            }
            return null;
        },
    },
    mounted() {
        this.openSupplierAssignmentForm(this.loan);
    },
    watch : {
        supplierSelected: function() {
            this.getSupplierData();
            this.getSupplierSTPAccount();
        },
        showFormPromptSupplierAssignment: function(val) {
            if(val == false) {
                this.resetForm();
            }
        }
    },
    methods: {
        async getLoans() {
            try {
                this.showLoading(true);
                const res = await axios.get('/api/loan-onboarding/get/not-assigned-loans');
                this.dataList = res.data;
                this.showLoading(false);
            } catch (error) {
                console.log(error);
            }
        },
        async handleSelected(proj) {
            window.open(`/project/${proj.id}`, '_blank');
        },
        showSupplierInformation(sid, loanIdSelected){
            this.currentSupplierID = sid;
            this.loanIdSelected = loanIdSelected;
            this.showFormPromptSupplierInfo = true;
            this.$refs.supplierDetails.update(sid);
            this.$refs.supplierDetails.getSupplierAgents(sid);
        },
        async getSuppliersList(familyGroupId) {
            try {
                this.showLoading(true);
                const res = await axios.get(`/api/loan-onboarding/get/suppliers-list/${familyGroupId}`);
                this.suppliersList = res.data;
                this.showLoading(false);
            } catch (e) {
                console.log(error);
            }
        },
        async openSupplierAssignmentForm(loan) {
            const loanIdSelected = loan.id;
            await this.getSuppliersList(this.familyGroupId);
            this.loanIdSelected = loanIdSelected;
        },
        async getSupplierData() {
            try {
                if(this.supplierSelected != null) {
                    this.showLoading(true);
                    const response = await axios.get('/api/supplier/detail/' + this.supplierSelected);
                    this.supplier = response.data;
                    this.logo_doc_file_url = response.data.logo_doc_file_url;
                    this.showLoading(false);
                } else {
                    this.supplier = null;
                }
            } catch (e) {
                this.showLoading(false);
                console.log(e);
            }
        },
        async getSupplierSTPAccount() {
            this.showLoading(true);
            try {
                let response = await axios.get(`/api/stp/v1/account/forSupplierId/${this.supplierSelected}`);
                if (response.data != null) {
                this.stpData = response.data;
                }
            } catch (e) {
                // this.failedOperationNotif("Algo salió mal", "No se ha podido crear la cuenta STP para este proveedor.")
                console.error("NO HAY INFORMACIÓN DE LA CUENTA STP");
            }
            this.showLoading(false);
        },
        getLegalProfileStatus(legalProfile) {
            if (legalProfile != null) {
                if (legalProfile.has_legal_claims == 1) {
                return "El Proveedor tiene coincidencias relevantes en material legal."
                } else {
                return "Perfil legal revisado."
                }
            } else {
                return "--";
            }
        },
        requestAssignment() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: `Aviso`,
                text: '¿Estás seguro de que deseas asignar este proveedor a la solicitud de crédito?',
                acceptText: "Confirmar",
                cancelText: "Cancelar",
                accept: this.doAssign
            })
        },
        async doAssign()
        {
            try {
                this.showLoading(true);
                await axios.put(`/api/loan-onboarding/put/assign-supplier`, {
                    loan_id: this.loanIdSelected,
                    supplier_id: this.supplierSelected
                });
                this.showLoading(false);
                this.saveSuccessNotif("¡Éxito!", "Se ha asignado el proveedor a la solicitud de crédito. Se notificó a ambos vía correo electrónico.");
                // await this.getLoans();
                this.$emit('updated');
            } catch (error) {
                console.log(error);
                this.showLoading(false);
            }
        },
        resetForm() {
            this.supplierSelected = null;
            this.loanIdSelected = null;
            this.supplier = null;
            this.stpData = null;
            this.logo_doc_file_url = '';
            this.showFormPromptSupplierAssignment = false;
        },
    }
}
</script>